import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';
import { ColorService } from '../../services/color.service';
import { IconComponent, SkeletonComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { SelectComponent } from '@kinomap-dev/ng-ui-lib/forms';
import { ProfileService } from '../../services/profile.service';
import { environment } from '../../../environments/environment';
import { ModalService } from '../../services/modal-service';
import { DialogRef } from '@angular/cdk/dialog';
import { LoginService } from '../../services/login.service';
import { LanguageSelect } from '../../components/language-select/language-select';

@Component({
  selector: 'app-settings',
  imports: [
    TranslateModule,
    SkeletonComponent,
    UpperFirstLetterPipe,
    IconComponent,
    LanguageSelect,
  ],
  templateUrl: './settings.html',
  styleUrl: './settings.scss',
})
export class Settings {
  protected colorService: ColorService = inject(ColorService);
  private profileService: ProfileService = inject(ProfileService);
  private modalService: ModalService = inject(ModalService);
  private loginService: LoginService = inject(LoginService);
  username: string | undefined = this.profileService.profile().username;
  avatarUrl: string | null = this.profileService.avatarUrl();

  navigateToWebsiteProfile(): void {
    const bearer: string | null = localStorage.getItem('user_access_token');
    const url: string = `${environment.website}/dashboard/setting/my-account?token=${bearer}`;
    if (!bearer) return;
    window.location.href = url;
  }

  logout(): void {
    const dialogRef: DialogRef<'cancel' | 'confirm', unknown> = this.modalService.openConfirmation<
      'cancel' | 'confirm'
    >({
      title: 'logout_confirm_modal.title',
      message: 'logout_confirm_modal.message',
      buttons: [
        { action: 'cancel', label: 'common.cancel', style: 'secondary' },
        { action: 'confirm', label: 'common.logout', style: 'danger' },
      ],
    });

    dialogRef.closed.subscribe((action: 'cancel' | 'confirm' | undefined) => {
      if (action === 'confirm') this.loginService.logout();
    });
  }
}
